import {Action, handleActions} from "redux-actions";
import {none, option} from "ts-option";
import {SurveyState} from "./SurveyState";
import {ACTIVITY_TEMPLATES_FETCHED, JOB_ACTIVITY_TEMPLATES_FETCHED} from "../../action/survey/actionType";

const initState: SurveyState = {
	activityTemplates: none,
	jobActivityTemplates: none
};

const reducer = handleActions({
	[ACTIVITY_TEMPLATES_FETCHED]: (state: SurveyState, action: Action<any>): SurveyState => {
		return {...state, activityTemplates: option(action.payload.activityTemplates)}
	},
	[JOB_ACTIVITY_TEMPLATES_FETCHED]: (state: SurveyState, action: Action<JOB_ACTIVITY_TEMPLATES_FETCHED>): SurveyState => {
		return {...state, jobActivityTemplates: option(action.payload.jobActivityTemplates)}
	},
}, initState);

export default reducer;